import { Dialog, DialogContent, List, Typography } from '@mui/material';
import { useGlobalCore } from '../../../core/modules/global';
import { useCompanyCore } from '../../../core/modules/company';
import { useUserCore } from '../../../core/modules/user';
import { SEARCH_COMPANY_DIALOG } from '../../../core/constants/dialog';
import { useMemo } from 'react';
import React from 'react';
import CompanyItem from './CompanyItem';

function CompaniesDialog() {
  const { dialog, closeDialog } = useGlobalCore();
  const { companies: userCompanies } = useUserCore();
  const { companies } = useCompanyCore();

  const availableCompanies = useMemo(() => {
    return companies.filter(
      (company) => !userCompanies.find(uCompany => uCompany.company.id === company.id)
    );
  }, [userCompanies, companies]);

  return (
    <Dialog
      classes={{
        paper: 'w-auto m-8 sm:m-24',
      }}
      onClose={closeDialog}
      open={dialog === SEARCH_COMPANY_DIALOG}
    >
      <DialogContent>
        <div className="flex flex-auto flex-col py-16 px-0 sm:px-16">
          <div className="flex flex-col">
            <div className="mb-16 flex items-center">
              <Typography className="text-2xl font-bold truncate">
                Compañías
              </Typography>
            </div>

            {!availableCompanies.length ? (
              <div className="flex flex-1 items-center justify-center h-full">
                <Typography color="text.secondary" className="text-sm">
                  No hay compañías disponibles
                </Typography>
              </div>
            ) : (
              <List className="w-full m-0 p-0 divide-y">
                {availableCompanies.map((company) => (
                  <CompanyItem key={company.id} company={company} companies={userCompanies} />
                ))}
              </List>
            )}
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}

export default CompaniesDialog;
